import React from 'react';
import UnstakeModal from './UnstakeModal';
import ConfirmModal from './ConfirmModal';
import ClaimModal from './ClaimModal';
import { StakingModalName } from './config';

const noop = () => {};

const StakingContext = /*#__PURE__*/React.createContext({
  unstake: noop,
  openModal: noop,
  closeModal: noop,
  claimReward: noop
});

const StakingProvider = ({
  children
}) => {
  const [stakingItem, setStakingItem] = React.useState();
  const [claimingItem, setClaimingItem] = React.useState();
  const [modal, setModal] = React.useState(null);
  const unstake = React.useCallback(data => {
    setStakingItem(data);
    setModal(StakingModalName.CONFIRM_UNSTAKE);
  }, []);
  const claimReward = React.useCallback(data => {
    setClaimingItem(data);
    setModal(StakingModalName.CLAIM);
  }, []);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setStakingItem(undefined);
    setClaimingItem(undefined);
    setModal(null);
  }, []);
  const context = React.useMemo(() => {
    return {
      modal: modal || undefined,
      unstake,
      openModal,
      closeModal,
      claimReward
    };
  }, [stakingItem, modal]); // Render the current modal

  const renderModal = () => {
    switch (modal) {
      case StakingModalName.UNSTAKING:
        return stakingItem && /*#__PURE__*/React.createElement(UnstakeModal, {
          item: stakingItem,
          onClose: () => {
            closeModal();
          }
        });

      case StakingModalName.CONFIRM_UNSTAKE:
        return /*#__PURE__*/React.createElement(ConfirmModal, {
          onClose: () => {
            closeModal();
          },
          onUnstake: () => {
            setModal(StakingModalName.UNSTAKING);
          }
        });

      case StakingModalName.CLAIM:
        return claimingItem && /*#__PURE__*/React.createElement(ClaimModal, {
          item: claimingItem,
          onClose: () => {
            closeModal();
          }
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(StakingContext.Provider, {
    value: context
  }, children, renderModal());
};

export const useStaking = () => {
  const {
    modal,
    unstake,
    claimReward
  } = React.useContext(StakingContext);
  return {
    modal,
    unstake,
    claimReward
  };
};
export default StakingProvider;